<template>
    <div>
        <div v-if="!evidences || evidences.length == 0" class="text-muted text-center" style="padding:100px 0;">
            {{translate('evidenceList.evidenceNotYet')}}
        </div>
        <table v-else class="table table-striped table-condensed" style="margin-top:-1px">
            <tbody>
                <tr v-for="e in evidences" :key="e.Date">
                    <td><span v-html="$options.filters.remEventCode(e.EventCode)"></span> {{e.Subject}}</td>
                    <td class="text-right">{{e.Date | datetime}}</td>
                </tr>
                <!-- <tr v-show="e.showDetails">
                    <td colspan="2" class="rem-body">
                        <pre v-if="!e.IsBodyHtml">{{e.Body}}</pre>
                        <div v-else :v-html="e.Body"></div>
                    </td>
                </tr> -->
            </tbody>
        </table>
    </div>
</template>
<script>
export default {
    props: {
        evidences: {
            type: Array,
            reqired: true
        }
    },
    methods: {
        // showDetails(e) {
        //     e.showDetails = !(e.showDetails || false);
        //     console.log('showDetails:', e.showDetails);
        //     this.$forceUpdate();
        // }
    }
}
</script>